import React, {useEffect, useState , useRef} from 'react'
import { useHistory, useParams } from "react-router-dom";
import axios from "axios";
import config from "../../../config.js";
import {trans} from "../../utils";
import QRCode from "react-qr-code";
import customer from "../../../assets/img/add-user.png";
import subCustomer from "../../../assets/img/add-user.png";
import Facility from "../../../assets/img/building.png";
import Building from "../../../assets/img/B-1.png";
import Floor from "../../../assets/img/stairs.png";
import Warehouse from "../../../assets/img/warehouse.png";
import Department from "../../../assets/img/department.png";
import Room from "../../../assets/img/room.png";
import ReactToPrint, { PrintContextConsumer } from "react-to-print";



const Index = (ComponentToRenderdata) => {
    let history = useHistory();
    const params = useParams();
    const SystemUrl = ComponentToRenderdata.SystemUrl;
    const token = localStorage.getItem('token')
    const [data, setdata] = useState([]);
    const search = window.location.search;
    let URLParams = new URLSearchParams(search);
    const [ticketData, setTicketData ] = useState([]);
    const routeChange = path => {
        history.push(path);
    }

    useEffect(() => {
            axios(config.SystemUrl + `RoomSpaceItem/${params.id}?include=facility.customer,room.department,facility.sub_customer,facility,building,floor,room,department,warehouse,assign_asset_item.supplier,assign_asset_item.documentations,assign_asset_item.asset_item.documentations,assign_asset_item.manufacturer,assign_asset_item,assign_asset_item.asset_item,assign_asset_item.asset_item.ecri,assign_asset_item.asset_item.pm_frequency,assign_asset_item.asset_item.qa_frequency,assign_asset_item.asset_item.calibration_frequency,assign_asset_item.asset_item.uom,assign_asset_item.asset_item.risk_class,assign_asset_item.asset_item.utility`, {
            headers: {
                "Accept": "application/json",
                "lang": "en",
                'Authorization': "Bearer " + token
            }
        })
            .then(result => setdata(result.data.data));

    }, [])
    useEffect(() => {
        axios(config.SystemUrl + `Ticket?asset_item_id=${params.id}`, {
            headers: {
                "Accept": "application/json",
                "lang": "en",
                'Authorization' : "Bearer " + token
            }
        })
            .then(result => setTicketData(result.data.data));

    }, [])

    var TicketCount = Object.keys(ticketData).length;

    const open = ticketData.filter(item => item.status === 'open')
    const ticketCountOpen = open.length;

    const close = ticketData.filter(item => item.status === 'closed')
    const ticketCountClose = close.length;

    const componentRef = useRef();
    const componentQR = useRef();
    const modulePermission = JSON.parse(localStorage.getItem("Ticket"));

    return (
        <>
            <div className="d-flex flex-column flex-xl-row">
                <div className="flex-column flex-lg-row-auto w-100 w-xl-350px row">
                    <div className="col-md-3">
                        <div className="symbol symbol-100px mb-7 symbol-square text-center mt-3" ref={componentQR}>
                            <QRCode value={config.FrontUrl + 'RoomSpaceItem/View/'+params.id}/>
                           {data.assign_asset_item &&
                            <h2 class=" mt-3 text-center">{trans(data.assign_asset_item.reference)}</h2>
                            }
                        </div>
                        <div className="card">
                            <div className="card-body pt-0">
                                <div className="fs-6">
                                    { data.assign_asset_item && data.assign_asset_item.asset_item &&
                                    <>
                                        <div className="fw-bolder mt-3">{trans('Common Name')}</div>
                                        <div className="text-gray-600">{trans(data.assign_asset_item.asset_item.common_name)}</div>
                                        <div className="separator mb-2 mt-2"></div>

                                        <div className="fw-bolder mt-3">{trans('Name')}</div>
                                        <div className="text-gray-600">{trans(data.assign_asset_item.asset_item.name)}</div>
                                        <div className="separator mb-2 mt-2"></div>
                                    </>
                                    }
                                    {data.assign_asset_item &&
                                    <>
                                        <div className="fw-bolder mt-3">{trans('Assign Asset / Item Ref.')}</div>
                                        <div className="text-gray-600">{trans(data.assign_asset_item.reference)}</div>
                                        <div className="separator mb-2 mt-2"></div>
                                    </>
                                    }
                                    {data.assign_asset_item && data.assign_asset_item.status_data &&
                                    <>
                                        <div className="fw-bolder mt-3">{trans('Status Data')}</div>
                                        <div className="text-gray-600">{trans(data.assign_asset_item.status_data.title)}</div>
                                        <div className="separator mb-2 mt-2"></div>
                                    </>
                                    }

                                    {data.assign_asset_item && data.assign_asset_item.asset_item && data.assign_asset_item.asset_item.ecri && data.assign_asset_item.asset_item.ecri.hasOwnProperty("ecri_name") &&
                                    <>
                                        <div className="fw-bolder mt-3">{trans('ECRI Name')}</div>
                                        <div
                                            className="text-gray-600">{trans(data.assign_asset_item.asset_item.ecri.ecri_name)}</div>
                                        <div className="separator mb-2 mt-2"></div>
                                        <div className="fw-bolder mt-3">{trans('ECRI Code')}</div>
                                        <div
                                            className="text-gray-600">{trans(data.assign_asset_item.asset_item.ecri.ecri_code)}</div>
                                        <div className="separator mb-2 mt-2"></div>
                                    </>
                                    }
                                    {data.assign_asset_item && data.assign_asset_item.asset_item && data.assign_asset_item.asset_item.risk_class &&
                                    <>
                                        <div className="fw-bolder mt-3">{trans('Risk Class')}</div>
                                        <div
                                            className="text-gray-600">{trans(data.assign_asset_item.asset_item.risk_class.title)}</div>
                                    </>
                                    }

                                    {data.assign_asset_item && data.assign_asset_item.asset_item && data.assign_asset_item.asset_item.uom &&
                                    <>
                                        <div className="separator mb-2 mt-2"></div>
                                        <div className="fw-bolder mt-3">UOM</div>
                                        <div
                                            className="text-gray-600">{trans(data.assign_asset_item.asset_item.uom.title)}</div>
                                    </>
                                    }
                                      {
                                        <>
                                            <div className="separator mb-2 mt-2"></div>
                                            <div className="fw-bolder mt-3">{trans('actual cost')}</div>
                                            <div
                                                className="text-gray-600">{data.total_actual_cost}</div>
                                        </>
                                        }
                                     {
                                        <>
                                            <div className="separator mb-2 mt-2"></div>
                                            <div className="fw-bolder mt-3">{trans('est cost')}</div>
                                            <div
                                                className="text-gray-600">{data.total_est_cost}</div>
                                        </>
                                        }
                                    {data.assign_asset_item && data.assign_asset_item.asset_item && data.assign_asset_item.asset_item.pm_frequency && data.assign_asset_item.asset_item.pm_frequency.hasOwnProperty("title") &&
                                    <>
                                        <div className="separator mb-2 mt-2"></div>
                                        <div className="fw-bolder mt-3">{trans('PM Frequency')}</div>
                                        <div
                                            className="text-gray-600">{trans(data.assign_asset_item.asset_item.pm_frequency.title)}</div>
                                    </>
                                    }

                                    {data.assign_asset_item && data.assign_asset_item.asset_item && data.assign_asset_item.asset_item.qa_frequency && data.assign_asset_item.asset_item.qa_frequency.hasOwnProperty("title") &&
                                    <>
                                        <div className="separator mb-2 mt-2"></div>
                                        <div className="fw-bolder mt-3">{trans('QA Frequency')}</div>
                                        <div
                                            className="text-gray-600">{trans(data.assign_asset_item.asset_item.qa_frequency.title)}</div>
                                    </>
                                    }


                                    {data.assign_asset_item && data.assign_asset_item.asset_item && data.assign_asset_item.asset_item.calibration_frequency && data.assign_asset_item.asset_item.calibration_frequency.hasOwnProperty("title") &&
                                    <>
                                        <div className="separator mb-2 mt-2"></div>
                                        <div className="fw-bolder mt-3">{trans('Calibration Frequency')}</div>
                                        <div
                                            className="text-gray-600">{trans(data.assign_asset_item.asset_item.calibration_frequency.title)}</div>
                                    </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-9">
                        <ul className="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-bold mb-8">

                            <li className="nav-item">
                                <a className="nav-link text-active-primary pb-4 active" data-toggle="tab"
                                   href="#kt_allocate_tab">
                                    {trans('Allocate Asset / Item')}
                                </a>
                            </li>

                            <li className="nav-item">
                                <a className="nav-link text-active-primary pb-4" data-toggle="tab"
                                   href="#kt_techincal_tab">
                                    {trans('Asset / Item Master Data')}
                                </a>
                            </li>

                            <li className="nav-item">
                                <a className="nav-link text-active-primary pb-4" data-toggle="tab" href="#kt_service">
                                    {trans('Procurement / Installation')}
                                </a>
                            </li>

                            {data.assign_asset_item && data.assign_asset_item.documentations && data.assign_asset_item.documentations.length > 0 ?
                                <li className="nav-item">
                                    <a className="nav-link text-active-primary pb-4" data-toggle="tab"
                                       href="#kt_docs_tab">
                                        {trans('Documentations')}
                                    </a>
                                </li> : ""
                            }

                            <li className="nav-item ms-auto">
                                { data.assign_asset_item && data.assign_asset_item.has_allocation === false && modulePermission.add !== 1 ?
                                    "" :
                                    <button onClick={() => {
                                        let url = "/" + "Ticket" + "/Add?hiddenInput[asset_item_id]="+params.id+"&parent_id="+params.id;
                                        routeChange(url);
                                    }}
                                            className="btn btn-light-primary font-weight-bold mr-2 waves-effect waves-light">
                                        <i className="bi bi-plus fs-3"></i> {trans('Create Ticket')}</button>
                                }
                            </li>
                        </ul>
                        <div className="tab-content" id="myTabContent">
                            <div className="tab-pane fade active show" id="kt_allocate_tab" role="tabpanel">
                                <div className="row g-5 g-xl-8">
                                    <div className="col-xl-4">
                                        <div className="card card-xl-stretch mb-xl-8">
                                            <div className="card-body d-flex align-items-center pt-1 pb-0">
                                                <div className="d-flex flex-column flex-grow-1 py-2 py-lg-13 me-2">
                                                    {data.facility && data.facility.customer &&
                                                    <>
                                                            <span className="fw-bolder text-dark fs-4 mb-2">
                                                               {trans('Customer')}
                                                            </span>
                                                        <span className="fw-bold text-muted fs-5">{data.facility.customer.name}</span>
                                                    </>
                                                    }
                                                </div>
                                                <img src={customer}
                                                     alt="" className="align-self-end h-80px" />
                                            </div>
                                        </div>
                                    </div>
                                    {data.facility && data.facility.sub_customer && data.facility.sub_customer.hasOwnProperty("name") &&
                                    <div className="col-xl-4">
                                        <div className="card card-xl-stretch mb-xl-8">
                                            <div className="card-body d-flex align-items-center pt-1 pb-0">
                                                <div className="d-flex flex-column flex-grow-1 py-2 py-lg-13 me-2">

                                                    <>
                                                            <span className="fw-bolder text-dark fs-4 mb-2">
                                                                {trans('Sub Customer')}
                                                            </span>
                                                        <span className="fw-bold text-muted fs-5">{data.facility.sub_customer.name}</span>
                                                    </>

                                                </div>
                                                <img src={subCustomer}
                                                     alt="" className="align-self-end h-80px" />
                                            </div>
                                        </div>
                                    </div>
                                    }

                                    {data.facility && data.facility.hasOwnProperty("name") &&
                                    <div className="col-xl-4">
                                        <div className="card card-xl-stretch mb-5 mb-xl-8">
                                            <div className="card-body d-flex align-items-center pt-1 pb-0">
                                                <div className="d-flex flex-column flex-grow-1 py-2 py-lg-13 me-2">
                                                    <>
                                                            <span className="fw-bolder text-dark fs-4 mb-2">
                                                                {trans('Facility')}
                                                            </span>
                                                        <span className="fw-bold text-muted fs-5">{data.facility.name}</span>
                                                    </>

                                                </div>
                                                <img src={Facility}
                                                     alt="" className="align-self-end h-80px" />
                                            </div>
                                        </div>
                                    </div>
                                    }
                                    {data.building && data.building.hasOwnProperty("title") &&
                                    <div className="col-xl-4">
                                        <div className="card card-xl-stretch mb-5 mb-xl-8">
                                            <div className="card-body d-flex align-items-center pt-1 pb-0">
                                                <div className="d-flex flex-column flex-grow-1 py-2 py-lg-13 me-2">
                                                    <>
                                                            <span className="fw-bolder text-dark fs-4 mb-2">
                                                                {trans('Building')}
                                                            </span>
                                                        <span className="fw-bold text-muted fs-5">{data.building.title}</span>
                                                    </>

                                                </div>
                                                <img src={Building}
                                                     alt="" className="align-self-end h-80px" />
                                            </div>
                                        </div>
                                    </div>
                                    }
                                    {data.floor && data.floor.hasOwnProperty("name") &&
                                    <div className="col-xl-4">
                                        <div className="card card-xl-stretch mb-5 mb-xl-8">
                                            <div className="card-body d-flex align-items-center pt-1 pb-0">
                                                <div className="d-flex flex-column flex-grow-1 py-2 py-lg-13 me-2">
                                                    <>
                                                            <span className="fw-bolder text-dark fs-4 mb-2">
                                                                {trans('Floor')}
                                                            </span>
                                                        <span className="fw-bold text-muted fs-5">{data.floor.name}</span>
                                                    </>

                                                </div>
                                                <img src={Floor}
                                                     alt="" className="align-self-end h-80px" />
                                            </div>
                                        </div>
                                    </div>
                                    }
                                    {data.warehouse && data.warehouse.hasOwnProperty("name") &&
                                    <div className="col-xl-4">
                                        <div className="card card-xl-stretch mb-5 mb-xl-8">
                                            <div className="card-body d-flex align-items-center pt-1 pb-0">
                                                <div className="d-flex flex-column flex-grow-1 py-2 py-lg-13 me-2">
                                                    <>
                                                            <span className="fw-bolder text-dark fs-4 mb-2">
                                                                {trans('Warehouse')}
                                                            </span>
                                                        <span className="fw-bold text-muted fs-5">{data.warehouse.name}</span>
                                                    </>

                                                </div>
                                                <img src={Warehouse}
                                                     alt="" className="align-self-end h-80px" />
                                            </div>
                                        </div>
                                    </div>
                                    }
                                    {data.room && data.room.department && data.room.department.hasOwnProperty("title") &&
                                    <div className="col-xl-4">
                                        <div className="card card-xl-stretch mb-5 mb-xl-8">
                                            <div className="card-body d-flex align-items-center pt-1 pb-0">
                                                <div className="d-flex flex-column flex-grow-1 py-2 py-lg-13 me-2">
                                                    <>
                                                            <span className="fw-bolder text-dark fs-4 mb-2">
                                                                {trans('Department')}
                                                            </span>
                                                        <span className="fw-bold text-muted fs-5">{data.room.department.title}</span>
                                                    </>

                                                </div>
                                                <img src={Department}
                                                     alt="" className="align-self-end h-80px" />
                                            </div>
                                        </div>
                                    </div>
                                    }
                                    {data.room &&
                                    <div className="col-xl-4">
                                        <div className="card card-xl-stretch mb-5 mb-xl-8">
                                            <div className="card-body d-flex align-items-center pt-1 pb-0">
                                                <div className="d-flex flex-column flex-grow-1 py-2 py-lg-13 me-2">
                                                    <>
                                                            <span className="fw-bolder text-dark fs-4 mb-2">
                                                                {trans('Room Space')}
                                                            </span>
                                                        <span className="fw-bold text-muted fs-5">{data.room.room_space_name}</span>
                                                    </>

                                                </div>
                                                <img src={Room}
                                                     alt="" className="align-self-end h-80px" />
                                            </div>
                                        </div>
                                    </div>
                                    }
                                </div>
                            </div>
                            <div className="tab-pane fade" id="kt_techincal_tab" role="tabpanel">
                                <div className="card">
                                    <div className="card-header card-header-stretch">
                                        <div className="card-title d-flex align-items-center">
                                            <h4 className="mb-1">{trans('Asset / Item Master Data')}</h4>
                                        </div>
                                    </div>
                                    <div className="card-body pt-0">
                                        <div className="fs-6">
                                            {data.assign_asset_item && data.assign_asset_item.manufacturer &&
                                            <>

                                                <div className="fw-bolder mt-3">{trans('Manufacturer')}</div>
                                                <div
                                                    className="text-gray-600">{trans(data.assign_asset_item.manufacturer.name)}</div>
                                            </>
                                            }
                                            {data.assign_asset_item && data.assign_asset_item.manufacturing_date &&
                                            <>
                                                <div className="separator mb-2 mt-2"></div>
                                                <div className="fw-bolder mt-3">{trans('Manufacturing Date')}</div>
                                                <div
                                                    className="text-gray-600">{trans(data.assign_asset_item.manufacturing_date)}</div>
                                            </>
                                            }
                                            {data.assign_asset_item && data.assign_asset_item.sw_version &&
                                            <>
                                                <div className="separator mb-2 mt-2"></div>
                                                <div className="fw-bolder mt-3">{trans('Software Version')}</div>
                                                <div className="text-gray-600">{trans(data.assign_asset_item.sw_version)}</div>
                                            </>
                                            }

                                            {data.assign_asset_item && data.assign_asset_item.model &&
                                            <>
                                                <div className="separator mb-2 mt-2"></div>
                                                <div className="fw-bolder mt-3">{trans('Model')}</div>
                                                <div className="text-gray-600">{trans(data.assign_asset_item.model)}</div>
                                            </>
                                            }
                                            {data.assign_asset_item && data.assign_asset_item.quantity &&
                                            <>
                                                <div className="separator mb-2 mt-2"></div>
                                                <div className="fw-bolder mt-3">{trans('Quantity')}</div>
                                                <div className="text-gray-600">{trans(data.assign_asset_item.quantity)}</div>
                                            </>
                                            }
                                            {data.assign_asset_item &&
                                            <>
                                                <div className="separator mb-2 mt-2"></div>
                                                <div className="fw-bolder mt-3">{trans('Serial Number')}</div>
                                                <div
                                                    className="text-gray-600">{data.assign_asset_item.serial_number}</div>
                                            </>
                                            }
                                            {data.assign_asset_item && data.assign_asset_item.expire_date &&
                                            <>
                                                <div className="separator mb-2 mt-2"></div>
                                                <div className="fw-bolder mt-3">{trans('Expire Date')}</div>
                                                <div
                                                    className="text-gray-600">{trans(data.assign_asset_item.expire_date)}</div>
                                            </>
                                            }
                                            {data.assign_asset_item && data.assign_asset_item.lot_no &&
                                            <>
                                                <div className="separator mb-2 mt-2"></div>
                                                <div className="fw-bolder mt-3">{trans('LOT No.')}</div>
                                                <div
                                                    className="text-gray-600">{trans(data.assign_asset_item.lot_no)}</div>
                                            </>
                                            }
                                            {data.assign_asset_item && data.assign_asset_item.batch_no &&
                                            <>
                                                <div className="separator mb-2 mt-2"></div>
                                                <div className="fw-bolder mt-3">{trans('Batch No.')}</div>
                                                <div
                                                    className="text-gray-600">{trans(data.assign_asset_item.batch_no)}</div>
                                            </>
                                            }

                                            {data.assign_asset_item && data.assign_asset_item.barcode &&
                                            <>
                                                <div className="separator mb-2 mt-2"></div>
                                                <div className="fw-bolder mt-3">{trans('Alternative Asset / Item Ref.')}</div>
                                                <div
                                                    className="text-gray-600">{trans(data.assign_asset_item.barcode)}</div>
                                            </>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane fade" id="kt_service" role="tabpanel">
                                <div className="card">
                                    <div className="card-header card-header-stretch">
                                        <div className="card-title d-flex align-items-center">
                                            <h4 className="mb-1">{trans('Procurement / Installation')}</h4>
                                        </div>
                                    </div>
                                    <div className="card-body pt-0">
                                        <div className="fs-6">
                                            {data.assign_asset_item && data.assign_asset_item.supplier &&
                                            <>

                                                <div className="fw-bolder mt-3">{trans('Supplier')}</div>
                                                <div
                                                    className="text-gray-600">{trans(data.assign_asset_item.supplier.name)}</div>
                                            </>
                                            }
                                            {data.assign_asset_item && data.assign_asset_item.installation_date &&
                                            <>

                                                <div className="fw-bolder mt-3">{trans('Installation Date')}</div>
                                                <div
                                                    className="text-gray-600">{trans(data.assign_asset_item.installation_date)}</div>
                                            </>
                                            }
                                            {data.assign_asset_item && data.assign_asset_item.in_service_date &&
                                            <>

                                                <div className="fw-bolder mt-3">{trans('In Service Date')}</div>
                                                <div
                                                    className="text-gray-600">{trans(data.assign_asset_item.in_service_date)}</div>
                                            </>
                                            }
                                            {data.assign_asset_item && data.assign_asset_item.contract && data.assign_asset_item.contract.length > 0 ?
                                                <>

                                                    <div className="fw-bolder mt-3">{trans('Contract')}</div>
                                                    <div
                                                        className="text-gray-600">{trans(data.assign_asset_item.contract_ref)}</div>
                                                </> : ""
                                            }
                                            {data.assign_asset_item && data.assign_asset_item.ownership &&
                                            <>

                                                <div className="fw-bolder mt-3">{trans('Ownership')}</div>
                                                <div
                                                    className="text-gray-600">{trans(data.assign_asset_item.ownership.title)}</div>
                                            </>
                                            }
                                            {data.assign_asset_item && data.assign_asset_item.depreciation_rate &&
                                            <>

                                                <div className="fw-bolder mt-3">{trans('Depreciation Rate')}</div>
                                                <div
                                                    className="text-gray-600">{trans(data.assign_asset_item.depreciation_rate)}</div>
                                            </>
                                            }
                                            {data.assign_asset_item && data.assign_asset_item.po_date &&
                                            <>

                                                <div className="fw-bolder mt-3">{trans('Purchase Order Date')}</div>
                                                <div
                                                    className="text-gray-600">{trans(data.assign_asset_item.po_date)}</div>
                                            </>
                                            }
                                            {data.assign_asset_item && data.assign_asset_item.po_value &&
                                            <>

                                                <div className="fw-bolder mt-3">{trans('Purchase Order Value')}</div>
                                                <div
                                                    className="text-gray-600">{trans(data.assign_asset_item.po_value)}</div>
                                            </>
                                            }

                                            {data.assign_asset_item && data.assign_asset_item.po_reference &&
                                            <>

                                                <div
                                                    className="fw-bolder mt-3">{trans('Purchase Order Reference')}</div>
                                                <div
                                                    className="text-gray-600">{trans(data.assign_asset_item.po_reference)}</div>
                                            </>
                                            }
                                            {data.assign_asset_item && data.assign_asset_item.warranty_start_date &&
                                            <>

                                                <div className="fw-bolder mt-3">{trans('Warranty start date')}</div>
                                                <div
                                                    className="text-gray-600">{trans(data.assign_asset_item.warranty_start_date)}</div>
                                            </>
                                            }
                                            {data.assign_asset_item && data.assign_asset_item.warranty_end_date &&
                                            <>

                                                <div className="fw-bolder mt-3">{trans('Warranty end date')}</div>
                                                <div
                                                    className="text-gray-600">{trans(data.assign_asset_item.warranty_end_date)}</div>
                                            </>
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane fade" id="kt_docs_tab" role="tabpanel">
                                <div className="card mb-5">
                                    <div className="card-header card-header-stretch">
                                        <div className="card-title d-flex align-items-center">
                                            <h4 className="mb-1">{trans('Asset / Item Documentations')}</h4>
                                        </div>
                                    </div>
                                    <div className="card-body pt-0">
                                        <table className="table mt-10">
                                            <thead>
                                            <tr>
                                                <th scope="col">{trans('Document Group')}</th>
                                                <th scope="col">{trans('Document Type')}</th>
                                                <th scope="col">{trans('Document')}</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {data.assign_asset_item && data.assign_asset_item.asset_item.documentations && data.assign_asset_item.asset_item.documentations.map(documentation => (
                                                <tr>
                                                    <td>{trans(documentation.parent_category)}</td>
                                                    <td>{trans(documentation.child_category)}</td>
                                                    <td>
                                                        <a href={documentation.file} target="_blank">{trans('Show Attachment')}</a>
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-header card-header-stretch">
                                        <div className="card-title d-flex align-items-center">
                                            <h4 className="mb-1">{trans('Assign Asset / Item Documentations')}</h4>
                                        </div>
                                    </div>
                                    <div className="card-body pt-0">
                                        <table className="table mt-10">
                                            <thead>
                                            <tr>
                                                <th scope="col">{trans('Document Group')}</th>
                                                <th scope="col">{trans('Document Type')}</th>
                                                <th scope="col">{trans('Document')}</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {data.assign_asset_item && data.assign_asset_item.documentations && data.assign_asset_item.documentations.map(documentation => (
                                                <tr>
                                                    <td>{trans(documentation.parent_category)}</td>
                                                    <td>{trans(documentation.child_category)}</td>
                                                    <td>
                                                        <a href={documentation.file} target="_blank">{trans('Show Attachment')}</a>
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row  p-1" ref={componentRef}>
                            <div class="print bg-white">
                                <div class="col-md-6">
                                    <div className="fs-6">
                                        { data.assign_asset_item && data.assign_asset_item.asset_item &&
                                        <>
                                            <div className="fw-bolder mt-3">{trans('Common Name')}</div>
                                            <div className="text-gray-600">{trans(data.assign_asset_item.asset_item.common_name)}</div>
                                            <div className="separator mb-2 mt-2"></div>

                                            <div className="fw-bolder mt-3">{trans('Name')}</div>
                                            <div className="text-gray-600">{trans(data.assign_asset_item.asset_item.name)}</div>
                                            <div className="separator mb-2 mt-2"></div>
                                        </>
                                        }
                                        {data.assign_asset_item &&
                                        <>
                                            <div className="fw-bolder mt-3">{trans('Assign Asset / Item Ref.')}</div>
                                            <div className="text-gray-600">{trans(data.assign_asset_item.reference)}</div>
                                            <div className="separator mb-2 mt-2"></div>
                                        </>
                                        }
                                        {data.assign_asset_item && data.assign_asset_item.status_data &&
                                        <>
                                            <div className="fw-bolder mt-3">{trans('Status Data')}</div>
                                            <div className="text-gray-600">{trans(data.assign_asset_item.status_data.title)}</div>
                                            <div className="separator mb-2 mt-2"></div>
                                        </>
                                        }

                                        {data.assign_asset_item && data.assign_asset_item.asset_item && data.assign_asset_item.asset_item.ecri && data.assign_asset_item.asset_item.ecri.hasOwnProperty("ecri_name") &&
                                        <>
                                            <div className="fw-bolder mt-3">{trans('ECRI Name')}</div>
                                            <div
                                                className="text-gray-600">{trans(data.assign_asset_item.asset_item.ecri.ecri_name)}</div>
                                            <div className="separator mb-2 mt-2"></div>
                                            <div className="fw-bolder mt-3">{trans('ECRI Code')}</div>
                                            <div
                                                className="text-gray-600">{trans(data.assign_asset_item.asset_item.ecri.ecri_code)}</div>
                                            <div className="separator mb-2 mt-2"></div>
                                        </>
                                        }
                                        {data.assign_asset_item && data.assign_asset_item.asset_item && data.assign_asset_item.asset_item.risk_class &&
                                        <>
                                            <div className="fw-bolder mt-3">{trans('Risk Class')}</div>
                                            <div
                                                className="text-gray-600">{trans(data.assign_asset_item.asset_item.risk_class.title)}</div>
                                        </>
                                        }

                                        {data.assign_asset_item && data.assign_asset_item.asset_item && data.assign_asset_item.asset_item.uom &&
                                        <>
                                            <div className="separator mb-2 mt-2"></div>
                                            <div className="fw-bolder mt-3">UOM</div>
                                            <div
                                                className="text-gray-600">{trans(data.assign_asset_item.asset_item.uom.title)}</div>
                                        </>
                                        }
                                        {data.assign_asset_item && data.assign_asset_item.asset_item && data.assign_asset_item.asset_item.pm_frequency && data.assign_asset_item.asset_item.pm_frequency.hasOwnProperty("title") &&
                                        <>
                                            <div className="separator mb-2 mt-2"></div>
                                            <div className="fw-bolder mt-3">{trans('PM Frequency')}</div>
                                            <div
                                                className="text-gray-600">{trans(data.assign_asset_item.asset_item.pm_frequency.title)}</div>
                                        </>
                                        }

                                        {data.assign_asset_item && data.assign_asset_item.asset_item && data.assign_asset_item.asset_item.qa_frequency && data.assign_asset_item.asset_item.qa_frequency.hasOwnProperty("title") &&
                                        <>
                                            <div className="separator mb-2 mt-2"></div>
                                            <div className="fw-bolder mt-3">{trans('QA Frequency')}</div>
                                            <div
                                                className="text-gray-600">{trans(data.assign_asset_item.asset_item.qa_frequency.title)}</div>
                                        </>
                                        }


                                        {data.assign_asset_item && data.assign_asset_item.asset_item && data.assign_asset_item.asset_item.calibration_frequency && data.assign_asset_item.asset_item.calibration_frequency.hasOwnProperty("title") &&
                                        <>
                                            <div className="separator mb-2 mt-2"></div>
                                            <div className="fw-bolder mt-3">{trans('Calibration Frequency')}</div>
                                            <div
                                                className="text-gray-600">{trans(data.assign_asset_item.asset_item.calibration_frequency.title)}</div>
                                        </>
                                        }
                                  
                                
                                                {data.assign_asset_item && data.assign_asset_item.manufacturer &&
                                                <>

                                                    <div className="fw-bolder mt-3">{trans('Manufacturer')}</div>
                                                    <div
                                                        className="text-gray-600">{trans(data.assign_asset_item.manufacturer.name)}</div>
                                                </>
                                                }
                                                {data.assign_asset_item && data.assign_asset_item.manufacturing_date &&
                                                <>
                                                    <div className="separator mb-2 mt-2"></div>
                                                    <div className="fw-bolder mt-3">{trans('Manufacturing Date')}</div>
                                                    <div
                                                        className="text-gray-600">{trans(data.assign_asset_item.manufacturing_date)}</div>
                                                </>
                                                }
                                                {data.assign_asset_item && data.assign_asset_item.sw_version &&
                                                <>
                                                    <div className="separator mb-2 mt-2"></div>
                                                    <div className="fw-bolder mt-3">{trans('Software Version')}</div>
                                                    <div className="text-gray-600">{trans(data.assign_asset_item.sw_version)}</div>
                                                </>
                                                }

                                                {data.assign_asset_item && data.assign_asset_item.model &&
                                                <>
                                                    <div className="separator mb-2 mt-2"></div>
                                                    <div className="fw-bolder mt-3">{trans('Model')}</div>
                                                    <div className="text-gray-600">{trans(data.assign_asset_item.model)}</div>
                                                </>
                                                }
                                                {data.assign_asset_item && data.assign_asset_item.quantity &&
                                                <>
                                                    <div className="separator mb-2 mt-2"></div>
                                                    <div className="fw-bolder mt-3">{trans('Quantity')}</div>
                                                    <div className="text-gray-600">{trans(data.assign_asset_item.quantity)}</div>
                                                </>
                                                }
                                                {data.assign_asset_item &&
                                                <>
                                                    <div className="separator mb-2 mt-2"></div>
                                                    <div className="fw-bolder mt-3">{trans('Serial Number')}</div>
                                                    <div
                                                        className="text-gray-600">{data.assign_asset_item.serial_number}</div>
                                                </>
                                                }
                                                {data.assign_asset_item && data.assign_asset_item.expire_date &&
                                                <>
                                                    <div className="separator mb-2 mt-2"></div>
                                                    <div className="fw-bolder mt-3">{trans('Expire Date')}</div>
                                                    <div
                                                        className="text-gray-600">{trans(data.assign_asset_item.expire_date)}</div>
                                                </>
                                                }
                                                {data.assign_asset_item && data.assign_asset_item.lot_no &&
                                                <>
                                                    <div className="separator mb-2 mt-2"></div>
                                                    <div className="fw-bolder mt-3">{trans('LOT No.')}</div>
                                                    <div
                                                        className="text-gray-600">{trans(data.assign_asset_item.lot_no)}</div>
                                                </>
                                                }
                                                {data.assign_asset_item && data.assign_asset_item.batch_no &&
                                                <>
                                                    <div className="separator mb-2 mt-2"></div>
                                                    <div className="fw-bolder mt-3">{trans('Batch No.')}</div>
                                                    <div
                                                        className="text-gray-600">{trans(data.assign_asset_item.batch_no)}</div>
                                                </>
                                                }

                                                {data.assign_asset_item && data.assign_asset_item.barcode &&
                                                <>
                                                    <div className="separator mb-2 mt-2"></div>
                                                    <div className="fw-bolder mt-3">{trans('Alternative Asset / Item Ref.')}</div>
                                                    <div
                                                        className="text-gray-600">{trans(data.assign_asset_item.barcode)}</div>
                                                </>
                                                }
                                            </div>
                                            
                                </div>
                                <div class="col-md-6">
                                {data.facility && data.facility.customer &&
                                                <>

                                                    <div className="fw-bolder mt-3">{trans('Customer')}</div>
                                                    <div
                                                        className="text-gray-600">{data.facility.customer.name}</div>
                                                </>
                                                }
                                               {data.facility && data.facility.sub_customer && data.facility.sub_customer.hasOwnProperty("name") &&
                                                <>

                                                    <div className="fw-bolder mt-3"> {trans('Sub Customer')}</div>
                                                    <div
                                                        className="text-gray-600">{data.facility.sub_customer.name}</div>
                                                </>
                                                }
                                                {data.facility && data.facility.hasOwnProperty("name") &&
                                                <>

                                                    <div className="fw-bolder mt-3"> {trans('Facility')}</div>
                                                    <div
                                                        className="text-gray-600">{data.facility.name}</div>
                                                </>
                                                }
                                                {data.building && data.building.hasOwnProperty("title") &&
                                                <>

                                                    <div className="fw-bolder mt-3">  {trans('Building')}</div>
                                                    <div
                                                        className="text-gray-600">{data.building.title}</div>
                                                </>
                                                }
                                                { data.warehouse && data.warehouse.hasOwnProperty("name") &&
                                                <>

                                                    <div className="fw-bolder mt-3"> {trans('Warehouse')}</div>
                                                    <div
                                                        className="text-gray-600">{data.warehouse.name}</div>
                                                </>
                                                }
                                                {data.room && data.room.department && data.room.department.hasOwnProperty("title") &&
                                                <>

                                                    <div className="fw-bolder mt-3"> {trans('Department')}</div>
                                                    <div
                                                        className="text-gray-600">{data.room.department.title}</div>
                                                </>
                                                }
                                                 {data.room &&
                                                <>

                                                    <div className="fw-bolder mt-3">   {trans('Room Space')}</div>
                                                    <div
                                                        className="text-gray-600">{data.room.room_space_name}</div>
                                                </>
                                                }
                                                <div className="fs-6">
                                                {data.assign_asset_item && data.assign_asset_item.supplier &&
                                                <>

                                                    <div className="fw-bolder mt-3">{trans('Supplier')}</div>
                                                    <div
                                                        className="text-gray-600">{trans(data.assign_asset_item.supplier.name)}</div>
                                                </>
                                                }
                                                {data.assign_asset_item && data.assign_asset_item.installation_date &&
                                                <>

                                                    <div className="fw-bolder mt-3">{trans('Installation Date')}</div>
                                                    <div
                                                        className="text-gray-600">{trans(data.assign_asset_item.installation_date)}</div>
                                                </>
                                                }
                                                {data.assign_asset_item && data.assign_asset_item.in_service_date &&
                                                <>

                                                    <div className="fw-bolder mt-3">{trans('In Service Date')}</div>
                                                    <div
                                                        className="text-gray-600">{trans(data.assign_asset_item.in_service_date)}</div>
                                                </>
                                                }
                                                {data.assign_asset_item && data.assign_asset_item.contract && data.assign_asset_item.contract.length > 0 ?
                                                    <>

                                                        <div className="fw-bolder mt-3">{trans('Contract')}</div>
                                                        <div
                                                            className="text-gray-600">{trans(data.assign_asset_item.contract_ref)}</div>
                                                    </> : ""
                                                }
                                                {data.assign_asset_item && data.assign_asset_item.ownership &&
                                                <>

                                                    <div className="fw-bolder mt-3">{trans('Ownership')}</div>
                                                    <div
                                                        className="text-gray-600">{trans(data.assign_asset_item.ownership.title)}</div>
                                                </>
                                                }
                                                {data.assign_asset_item && data.assign_asset_item.depreciation_rate &&
                                                <>

                                                    <div className="fw-bolder mt-3">{trans('Depreciation Rate')}</div>
                                                    <div
                                                        className="text-gray-600">{trans(data.assign_asset_item.depreciation_rate)}</div>
                                                </>
                                                }
                                                {data.assign_asset_item && data.assign_asset_item.po_date &&
                                                <>

                                                    <div className="fw-bolder mt-3">{trans('Purchase Order Date')}</div>
                                                    <div
                                                        className="text-gray-600">{trans(data.assign_asset_item.po_date)}</div>
                                                </>
                                                }
                                                {data.assign_asset_item && data.assign_asset_item.po_value &&
                                                <>

                                                    <div className="fw-bolder mt-3">{trans('Purchase Order Value')}</div>
                                                    <div
                                                        className="text-gray-600">{trans(data.assign_asset_item.po_value)}</div>
                                                </>
                                                }

                                                {data.assign_asset_item && data.assign_asset_item.po_reference &&
                                                <>

                                                    <div
                                                        className="fw-bolder mt-3">{trans('Purchase Order Reference')}</div>
                                                    <div
                                                        className="text-gray-600">{trans(data.assign_asset_item.po_reference)}</div>
                                                </>
                                                }
                                                {data.assign_asset_item && data.assign_asset_item.warranty_start_date &&
                                                <>

                                                    <div className="fw-bolder mt-3">{trans('Warranty start date')}</div>
                                                    <div
                                                        className="text-gray-600">{trans(data.assign_asset_item.warranty_start_date)}</div>
                                                </>
                                                }
                                                {data.assign_asset_item && data.assign_asset_item.warranty_end_date &&
                                                <>

                                                    <div className="fw-bolder mt-3">{trans('Warranty end date')}</div>
                                                    <div
                                                        className="text-gray-600">{trans(data.assign_asset_item.warranty_end_date)}</div>
                                                </>
                                                }

                                            </div>
                                </div>
                            </div>
                        </div>
                        <ReactToPrint 
                        trigger={() => <button className="btn btn-success"> Print Asset/Item </button>}
                        content={() => componentRef.current}
                        />

                        <ReactToPrint 
                        trigger={() => <button className="btn btn-primary"> Print QR Code </button>}
                        content={() => componentQR.current}
                        />
                    </div>
                </div>
            </div>

        </>
    )
}
export default Index;
